export default __webpack_public_path__ + "static/media/manage-school-blue.f0163c46.svg";